import type { GraphPathInsight, InsightSummary } from "../types/api";
import { apiClient } from "./api-client";

export interface TrendResponse {
  success: boolean;
  trend: Array<{
    timestamp: string;
    glucose: number;
    unit: string;
  }>;
}

export interface SummaryResponse {
  success: boolean;
  summary: InsightSummary;
}

export interface GraphPathsResponse {
  success: boolean;
  graphPaths: GraphPathInsight[];
}

export function fetchPatientSummary(
  patientId: string,
  signal?: AbortSignal,
): Promise<SummaryResponse> {
  return apiClient<SummaryResponse>(`/insights/${patientId}/summary`, {
    method: "GET",
    signal,
  });
}

export function fetchPatientTrend(
  patientId: string,
  hours: number,
  signal?: AbortSignal,
): Promise<TrendResponse> {
  const search = new URLSearchParams({ hours: String(hours) }).toString();
  return apiClient<TrendResponse>(`/insights/${patientId}/trend?${search}`, {
    method: "GET",
    signal,
  });
}

export function fetchPatientGraphPaths(
  patientId: string,
  signal?: AbortSignal,
): Promise<GraphPathsResponse> {
  return apiClient<GraphPathsResponse>(`/insights/${patientId}/paths`, {
    method: "GET",
    signal,
  });
}
